import { createFileRoute } from "@tanstack/react-router";

import { legalFacts } from "@/features/legal/utils/legal-facts";
import { LegalDocumentPage } from "@/features/legal/components/legal-page";
import { pageMeta } from "@/lib/seo";
import { m } from "@/paraglide/messages.js";

export const Route = createFileRoute("/(public)/dpa/")({
  // Out of search until `legalEntity` holds the real company details.
  staticData: { sitemap: false },
  head: () => ({ meta: pageMeta({ title: m.legal_dpa_title(), description: m.legal_dpa_description() }) }),
  loader: () => ({ crumb: m.legal_dpa_title() }),
  component: () => <LegalDocumentPage title={m.legal_dpa_title()} source={m.legal_dpa_body(legalFacts())} />,
});
